import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SimulationFeedbackService } from 'src/app/modules/simulation-started/services';

import { SimulationService } from 'src/app/modules/simulation/services';

@Component({
    selector: 'save-feedback-dialog-app',
    templateUrl: 'save-feedback-dialog.component.html',
    styleUrls: ['./save-feedback-dialog.component.scss'],
})
export class SaveFeedBackDialogComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<SaveFeedBackDialogComponent>,
        public simulationService: SimulationService,
        public router: Router,
        private simulationFeedbackService: SimulationFeedbackService,
        private ngxService: NgxUiLoaderService,
    ) {}
    ngOnInit(): void {}
    onClickSaveFeedback() {
        if (this.data.feedback && this.data.feedback.length > 0) {
            let temp = this.data.feedback.filter((d: any) => d.child.length > 0);
            let getChild = _.flattenDeep(temp.map((d: any) => d.child));
            let oldReply = getChild.filter((d: any) => d.id);
            let newReply = getChild.filter((d: any) => !d.id);
            let raw = this.data.feedback.concat(oldReply);

            const feedback = raw.map((d: any) => ({
                simulationId: d.simulationId,
                feedbackId: d.id,
                feedback: d.isDelete ? '' : d.feedback,
                parentFeedbackId: d.parentFeedbackId ? d.parentFeedbackId : 0,
            }));

            this.ngxService.start();
            this.simulationFeedbackService.saveFeedbackAfterEdit(feedback).subscribe(
                res => {
                    if (Boolean(res.status)) {
                        this.dialogRef.close('success');
                    }
                },
                () => {
                    this.dialogRef.close('error');
                },
                () => {
                    this.ngxService.stop();
                },
            );
            this.simulationFeedbackService.addComment(newReply).subscribe(
                res => {
                    if (Boolean(res.status)) {
                        this.dialogRef.close('success');
                    }
                },
                () => {
                    this.dialogRef.close('error');
                },
                () => {
                    this.ngxService.stop();
                },
            );
        } else {
            this.dialogRef.close('success');
            // this.dialogRef.close();
        }
    }
    onClose() {
        this.dialogRef.close();
    }
}
